import { render, staticRenderFns } from "./SfBreadcrumbs.vue?vue&type=template&id=f679acc6&functional=true&"
import script from "./SfBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./SfBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./SfBreadcrumbs.vue?vue&type=style&index=0&id=f679acc6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports